import { LayoutDirection } from 'common/components/Graph/Models/LayoutDirection';

export const graphDirection: Record<string, LayoutDirection> = {
    RTL: LayoutDirection.RightToLeft,
    LTR: LayoutDirection.LeftToRight,
};
